<template>
  <div ref="wrapper" class="wrapper">
    <div ref="chessboard-wrapper" class="chessboard-wrapper">
      <div class="chessboard-container text-center">
        <div
          :id="playerId"
          class="chessboard"
          :style="isLocked ? {'pointer-events': 'none'} : {}"
        ></div>
        <div class="board-image" :style="chessboardImageStyle">
          <slot></slot>
        </div>
      </div>
      <div v-if="isCorrectModalShow" class="isCorrect">
        <span
          :class="isCorrect ? 'icon-Colorful-correct' : 'icon-Colorful-error'"
        >
          <span class="path1"></span>
          <span class="path2"></span>
        </span>
      </div>
    </div>
    <b-row
      v-show="!hideToolBar"
      class="chessboard-toolbar mt-2 mx-0 mt-md-3"
      :class="{
        'fixed-height': !isModalJudgementResultShow && toolbar !== 'board',
        'mt-3': toolbar === 'checkVariation',
      }"
    >
      <b-col cols="12" class="p-0 position-relative">
        <ChessboardToolbar
          :mode="chessboardToolbarMode"
          :step-type="stepType"
          :current-step="currentStep"
          :max-step="!isTestPlay && errorStep ? errorStep : maxStep"
          :question="question"
          :has-support-game="hasSupportGame"
          :has-influence="hasInfluence"
          :has-test-play="hasTestPlay"
          :has-judge="hasJudge"
          :support-count="supportCount"
          :kifu-review-game="kifuReviewGame"
          @item-click="onToolbarClick"
          @move-chess="moveChess"
          @check-answer-tab="checkAnswerTab"
          @on-click-video="onClickVideo"
          @step-change="goto"
          @check-step="checkStep"
          @sticker-select="$emit('sticker-select', $event)"
        ></ChessboardToolbar>
      </b-col>
    </b-row>
    <modal-message-box
      v-if="isModalMessageBoxShow"
      :result-content="$t('確定要認輸？')"
      :buttons="messageBoxButtons"
      @on-item-click="onModalMessageBoxClick"
    >
    </modal-message-box>
  </div>
</template>

<script>
import WgoHelper, {EVENT_TYPE} from 'wgo-helper';
import {getMorphologyInfluence} from '@/lib/wgo/influence';
import {InfluenceController} from '@/lib/wgo/utils';

import KOMI from '@/config/komi.js';
import GameConfig from '@/json/game.json';
import GameHelper from '@/lib/wgo/gameHelper.js';
import ChessboardToolbar from '@/components/Chessboard/ChessboardToolbar.vue';
import ModalMessageBox from '@/components/Modal/ModalMessageBox.vue';
import delay from '@/lib/base/delay.js';
import filters from '@/lib/base/filters.js';
import BackEvent from '@/lib/base/backEvent.js';
import {CHESSBOARD_MODES} from '@/constant/chessboard.js';
import _ from 'lodash';
import {mapState} from 'vuex';

export default {
  components: {
    ChessboardToolbar,
    ModalMessageBox,
  },
  props: {
    customToolbar: {
      type: String,
      default: null,
    },
    mode: {
      type: String,
      default: CHESSBOARD_MODES.BOARD,
      validator: (val) => {
        return Object.values(CHESSBOARD_MODES).includes(val);
      },
    },
    boardSize: {
      type: [Number, String],
      default: 9,
    },
    sgf: {
      type: String,
      default: '',
    },
    isTsumeStart: {
      type: Boolean,
      default: false,
    },
    question: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isQuestionNext: {
      type: Boolean,
      default: false,
    },
    toolbar: {
      type: String,
      default: '',
    },
    checkAnswerSelectedTab: {
      type: String,
      default: '',
    },
    isVerification: {
      type: Boolean,
      default: false,
    },
    shouldVariationPrevFirst: {
      type: Boolean,
      default: true,
    },
    isLocked: {
      type: Boolean,
      default: false,
    },
    hideToolBar: {
      type: Boolean,
      default: false,
    },
    hasBorder: {
      type: Boolean,
      default: false,
    },
    variation: {
      type: Array,
      default: () => {
        return [];
      },
    },
    hasSupportGame: {
      type: Boolean,
      default: false,
    },
    hasInfluence: {
      type: Boolean,
      default: false,
    },
    hasTestPlay: {
      type: Boolean,
      default: true,
    },
    hasJudge: {
      type: Boolean,
      default: true,
    },
    isSupportStep: {
      type: Boolean,
      default: false,
    },
    supportCount: {
      type: Number,
      default: 0,
    },
    kifuReviewGame: {
      type: Object,
      default: () => {
        return {};
      },
    },
    komi: {
      type: Number,
      default: KOMI.DEFAULT,
    },
    moveOptions: {
      type: Array,
      default: null,
    },
    needResize: {
      type: Boolean,
      default: true,
    },
    errorStep: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isMounted: false,
      playerId: `player-${Math.random().toString(36).slice(2)}`,
      wgoHelper: null,
      influenceController: null,
      isAiThinking: false,
      chessboardToolbarMode: this.toolbar,
      isScoreModalShow: false,
      position: null,
      doubleCheckPosition: null,
      isModalMessageBoxShow: false,
      isModalJudgementResultShow: false,
      messageBoxButtons: [
        {
          variant: 'secondary',
          value: 'cancle',
          content: '取消',
        },
        {
          variant: 'primary',
          value: 'confirm',
          content: '確定',
        },
      ],
      theme: {
        blackStoneColor: '#4a4141',
        gridLinesColor: '#6c4c1f',
        starColor: '#6c4c1f',
        starSize(board) {
          if (board.stoneRadius < 12) {
            return board.stoneRadius / 8 + 0.5;
          } else {
            return board.stoneRadius / 8 + 4;
          }
        },
        stoneSize(board) {
          return Math.min(board.fieldWidth, board.fieldHeight) / 2.2;
        },
        mCharCode: 59686,
        mColor: '#ff855e',
      },
      action: null,
      scoreResult: null,
      winningWay: '',
      isCorrectModalShow: false,
      isCorrect: false,
      isAnswering: true,
      chessType: '',
      currentStep: 0,
      maxStep: 0,
      storeStep: 0,
      currentBoardSize: this.boardSize,
      suggestPathMove: null,
      isTestPlay: false,
      testPlayState: {}, // 試下狀態保存
      isInfluence: false,
      errorStepMove: null,
    };
  },
  computed: {
    ...mapState('env', ['isLoading', 'width', 'height']),
    user() {
      return this.$store.state.user;
    },
    isTeacher() {
      return this.$store.getters['user/isTeacher'];
    },
    userColor() {
      return this.$store.state.aiGame.userColor;
    },
    scoreRule() {
      return this.$store.state.aiGame.scoreRule;
    },
    chessboardImageStyle() {
      const backgroundColor = '#f4d99b';
      const borderColor = this.isTestPlay ? '#FF855E' : '#ffbd5a';
      const borderStyle = this.$device.isMobile
        ? ''
        : `0 0 0 8px ${borderColor}`;
      return {
        backgroundColor,
        borderRadius: '8px',
        'box-shadow': this.hasBorder || this.isTestPlay ? borderStyle : 'none',
      };
    },
    turnColor() {
      if (this.wgoHelper) {
        return this.wgoHelper.turnColor;
      } else {
        return 'black';
      }
    },
    stepType() {
      if (this.wgoHelper) {
        return this.wgoHelper.showStepType;
      } else {
        return '';
      }
    },
    laoziSetting() {
      if (!this.user.userData?.config) {
        return this.$device.isMobile;
      }
      return this.user.userData?.config?.laoziSetting === 'confirm';
    },
    isSpectate() {
      return this.$route.query.spectateId != null;
    },
    isLastMovePass() {
      const sgf = this.sgf;
      const moves = sgf.split(';');
      if (moves.length === 0) return false;
      const lastMove = moves[moves.length - 1];
      return /\[tt\]|\[\]|\[pass\]/i.test(lastMove);
    },
  },
  watch: {
    'wgoHelper.sgf'() {
      this.currentBoardSize = this.wgoHelper.boardWidth;
      this.$emit('onSgfChange', this.wgoHelper.sgf);
    },
    currentBoardSize() {
      this.$emit('onBoardSizeChange', this.currentBoardSize);
    },
    currentStep: {
      async handler() {
        this.$emit('current-step-change', this.currentStep);
        await this.$nextTick();
        const step = this.wgoHelper.step;
        if (!this.isTestPlay && step === this.errorStep) {
          const move = this.wgoHelper.node.move;
          this.addErrorStepMarkup(move);
        } else {
          this.removeErrorStepMarkup();
        }
      },
      immediate: true,
    },
    maxStep() {
      this.$emit('max-step-change', this.maxStep);
    },
    chessboardToolbarMode() {
      this.$emit('chessboard-toolbar-mode-change', this.chessboardToolbarMode);
    },
    turnColor(newValue) {
      if (newValue && this.isScoreModalShow) {
        this.isScoreModalShow = false;
        this.chessboardToolbarMode = this.toolbar;
      }
    },
    isTsumeStart(newValue) {
      if (newValue) {
        this.initialTsumePlayer();
        this.questionNext();
      }
    },
    isQuestionNext(newValue) {
      if (newValue) {
        this.questionNext();
      }
    },
    laoziSetting(newValue) {
      if (this.wgoHelper && this.wgoHelper.editable) {
        this.wgoHelper.editable.isNoBoldGrid = !newValue;
        if (!newValue) {
          this.cancelDoubleCheckPosition();
        }
      }
    },
    variation(newValue) {
      this.influenceController.removeInfluence();
      if (newValue.length !== 0) {
        this.storeStep = this.currentStep;
        if (this.shouldVariationPrevFirst) {
          this.checkStep('prev');
        }
        this.currentStep = 0;
        this.wgoHelper.gotoVariantion(newValue);
        this.wgoHelper.showStep('all');
        this.checkStep('next');
      } else {
        this.wgoHelper.loadSgf(this.sgf);
        this.currentStep = this.storeStep;
        this.wgoHelper.showStep('normal');
        this.goto(this.currentStep);
      }
    },
    toolbar(newValue) {
      if (newValue) {
        this.chessboardToolbarMode = this.toolbar;
      }
    },
    height() {
      this.redrawBoard();
    },
    width() {
      this.redrawBoard();
    },
  },
  created() {
    const store = this.$store;
    const isNeedSendTime = this.isVerification;
    const updateGame = this.updateGame;
    const nextMove = this.nextMove;
    this.action = {
      getUserColor() {
        return store.state.aiGame.userColor;
      },
      setSgf(sgf) {
        store.commit('aiGame/setSgf', sgf);
      },
      updateGame({move, deltaMs}) {
        return updateGame(move, deltaMs, isNeedSendTime);
      },
      nextMove() {
        return nextMove();
      },
      resign() {
        return store.dispatch('aiGame/resign');
      },
      getJudgement() {
        return store.dispatch('aiGame/getJudgement');
      },
      confirmJudgement() {
        return store.dispatch('aiGame/confirmJudgement');
      },
      overGameData() {
        store.commit('aiGame/overGameData');
      },
    };
  },
  mounted() {
    this.isMounted = true;
    if (this.mode === CHESSBOARD_MODES.GAME) {
      this.wgoHelper = new GameHelper(
        this.mode,
        this.playerId,
        this.sgf || `(;CA[big5]SZ[${this.currentBoardSize}])`,
        {theme: this.theme, action: this.action}
      );
    } else if (this.mode === CHESSBOARD_MODES.PVP) {
      this.wgoHelper = new WgoHelper(
        CHESSBOARD_MODES.GAME,
        this.playerId,
        this.sgf || `(;CA[big5]SZ[${this.currentBoardSize}])`,
        {theme: this.theme}
      );
    } else if (this.mode === CHESSBOARD_MODES.ENDGAME) {
      this.wgoHelper = new GameHelper(
        CHESSBOARD_MODES.GAME,
        this.playerId,
        this.sgf || `(;CA[big5]SZ[${this.currentBoardSize}])`,
        {theme: this.theme, action: this.action, isEndGame: true}
      );
    } else if (this.mode === CHESSBOARD_MODES.FUSEKI) {
      this.wgoHelper = new GameHelper(
        CHESSBOARD_MODES.GAME,
        this.playerId,
        this.sgf || `(;CA[big5]SZ[${this.currentBoardSize}])`,
        {theme: this.theme, action: this.action}
      );
    } else {
      this.wgoHelper = new WgoHelper(
        this.mode,
        this.playerId,
        this.sgf || `(;CA[big5]SZ[${this.currentBoardSize}])`,
        {
          theme: this.theme,
          displayVariations: this.toolbar === 'checkAnswer',
        }
      );
    }
    this.redrawBoard();
    this.influenceController = new InfluenceController(
      this.wgoHelper,
      getMorphologyInfluence
    );
    this.wgoHelper.on('update', async () => {
      this.maxStep =
        this.isTestPlay ||
        (this.toolbar === 'checkAnswer' &&
          this.checkAnswerSelectedTab !== 'question')
          ? this.wgoHelper.completeStep
          : this.wgoHelper.mainStep;
      this.currentStep = this.wgoHelper.step;

      this.$emit('board-grid-change', this.wgoHelper.boardGrid);
      this.$emit('cap-count-change', this.wgoHelper.captureCount);
      this.$emit('turn-color-change', this.wgoHelper.turnColor);
      this.$emit('complete-step-change', this.wgoHelper.player.kifuReader.step);
      await this.$nextTick();
      if (!this.isSupportStep) {
        this.isInfluence = false;
        this.influenceController.removeInfluence();
      }
    });
    if (this.mode === CHESSBOARD_MODES.GAME) {
      this.initialGamePlayer();
    } else if (this.mode === CHESSBOARD_MODES.TSUME) {
      this.wgoHelper.setConfig({displayVariations: false});
      this.wgoHelper.setFrozen(true);
      this.wgoHelper.on(EVENT_TYPE.PLAY, () => {
        this.$playSound('play');
      });
    } else if (this.mode === CHESSBOARD_MODES.PVP) {
      this.$emit('step-type-change', this.wgoHelper.showStepType);
      this.wgoHelper.last();
    } else if (this.mode === CHESSBOARD_MODES.ENDGAME) {
      this.initialEndgamePlayer();
    } else if (this.mode === CHESSBOARD_MODES.FUSEKI) {
      this.initialFusekiPlayer();
    } else {
      this.wgoHelper.showAnswerMarkups();
      this.toolbar !== 'checkAnswer' && this.toolbar !== 'board'
        ? this.wgoHelper.last()
        : null;
      this.toolbar === 'checkAnswer' && this.mode === CHESSBOARD_MODES.BOARD
        ? this.wgoHelper.setEditable(true)
        : this.wgoHelper.setFrozen(true);
      this.$emit('cap-count-change', this.wgoHelper.captureCount);
    }
    this.wgoHelper.editable.isNoBoldGrid = !this.laoziSetting;
    this.wgoHelper.setBeforeClick((x, y) => {
      if (!this.isOnMoveOptions(x, y)) return false;
      this.beforeLaozi(x, y);
    });
    this.wgoHelper.setDrawHook(({x, y, type}) => {
      if (
        type === 'outline' &&
        !this.wgoHelper.isBranch({x, y}) &&
        this.toolbar === 'checkAnswer' &&
        this.checkAnswerSelectedTab === 'answer' &&
        !this.isTestPlay
      ) {
        return false;
      } else if (
        type === 'outline' &&
        this.toolbar === 'checkAnswer' &&
        (this.checkAnswerSelectedTab === 'question' ||
          this.checkAnswerSelectedTab === 'myAnswer') &&
        !this.isTestPlay
      ) {
        return false;
      }
      return true;
    });
  },
  methods: {
    initialGamePlayer() {
      this.$emit('board-grid-change', this.wgoHelper.boardGrid);
      this.$emit('cap-count-change', this.wgoHelper.captureCount);
      this.$emit('turn-color-change', this.wgoHelper.turnColor);
      this.$emit('step-type-change', this.wgoHelper.showStepType);
      this.$emit('complete-step-change', this.wgoHelper.player.kifuReader.step);

      this.wgoHelper.on('play', () => {
        this.wgoHelper.clearAllMarkups('MONO');
        this.wgoHelper.clearAllMarkups('SCR');
        this.$playSound('play');
        this.$emit('play');
      });
      this.wgoHelper.on('AiPass', (game) => {
        this.$emit('ai-pass', game);
      });
      this.wgoHelper.on('Judge', (judge) => {
        this.$emit('judge', judge);
        this.showJudgementResult(judge);
      });
      this.wgoHelper.on('AiMove', (game) => {
        this.$emit('ai-move', game);
      });
      this.wgoHelper.on('UserMove', (game) => {
        this.$emit('user-move', game);
      });
      this.wgoHelper.on('AiThinkStart', () => {
        this.isAiThinking = true;
      });
      this.wgoHelper.on('AiThinkOver', () => {
        this.isAiThinking = false;
      });
      this.wgoHelper.on('error', (error) => {
        this.$emit('error', error);
      });
      this.wgoHelper.on('AiTalk', (data) => {
        this.$emit('ai-talk', data);
      });
      this.wgoHelper.on(
        'gameOverAndGetItem',
        ({isWin, winningWay, errorStep}) => {
          if (this.mode === CHESSBOARD_MODES.ENDGAME) {
            this.$emit('game-over', {isWin, winningWay, errorStep});
          } else if (this.mode === CHESSBOARD_MODES.FUSEKI) {
            this.$emit('game-over', {isWin, score: 0});
          } else {
            this.$emit('game-over', {isWin, winningWay});
          }
          if (this.isVerification) {
            this.$playSound('finishVerification');
          } else {
            this.$playSound(isWin ? 'win' : 'lose');
          }
        }
      );
      this.wgoHelper.on('fuseki-over', ({score, winner}) => {
        const isWin = winner == this.userColor;
        this.$emit('game-over', {isWin, score});
        this.$playSound(isWin ? 'win' : 'lose');
      });
      this.wgoHelper.gameStart();
    },
    initialEndgamePlayer() {
      this.wgoHelper.last();
      this.initialGamePlayer();
    },
    initialFusekiPlayer() {
      this.wgoHelper.last();
      this.initialGamePlayer();
      this.wgoHelper.displayMoveOptions = true;
      this.setMoveOptions();
    },
    setMoveOptions() {
      if (this.wgoHelper.displayMoveOptions) {
        const moveOptions = this.$store.state.aiGame.moveOptions;
        this.wgoHelper.setMoveOptions(moveOptions);
      }
    },
    initialTsumePlayer() {
      this.wgoHelper.on('correct', async () => {
        if (!this.wgoHelper.player.frozen) {
          this.$emit('answer-tsume');
          this.wgoHelper.setFrozen(true);
          await delay(300);
          this.onQuestionDone(true);
        }
      });
      this.wgoHelper.on('incorrect', async () => {
        if (!this.wgoHelper.player.frozen) {
          this.$emit('answer-tsume');
          this.wgoHelper.setFrozen(true);
          await delay(300);
          this.onQuestionDone(false);
        }
      });
      this.wgoHelper.on('playerLock', async (value) => {
        this.$emit('is-player-lock', value);
      });
    },
    isOnMoveOptions(x, y) {
      if (this.isTestPlay) return true;
      return this.wgoHelper.isOnMoveOptions(x, y);
    },
    onQuestionDone(isCorrect) {
      if (this.isAnswering === false) return;
      const userAnswer = this.wgoHelper.getAnswerResult();
      this.isAnswering = false;
      this.isCorrect = isCorrect;
      this.isCorrectModalShow = true;
      this.$emit('update-tsume-question', {isCorrect, userAnswer});
      this.$playSound(isCorrect ? 'correct' : 'incorrect');
      setTimeout(() => {
        this.isCorrectModalShow = false;
      }, 1000);
    },
    questionNext() {
      this.isAnswering = true;
      this.isCorrectModalShow = false;
      const sgf = this.question.sgf;
      this.wgoHelper.loadSgf(sgf);
      this.wgoHelper.clearNextLabel();
      this.wgoHelper.setFrozen(false);
      if (
        this.question.category === 'MARKUP' ||
        this.wgoHelper.player?.kifu?.info?.TYPE === 'MARKUP'
      ) {
        this.chessType = 'markup';
        this.wgoHelper.setConfig({
          stoneStyle: 'M',
        });
      } else {
        this.chessType = '';
        this.wgoHelper.setConfig({
          stoneStyle: null,
        });
      }
    },
    // about chessboardtoolbar
    onToolbarClick(event) {
      switch (event) {
        case 'handTriangle':
          this.wgoHelper.showStep('all');
          this.$emit('step-type-change', this.wgoHelper.showStepType);
          break;
        case 'handAll':
          this.wgoHelper.showStep('normal');
          this.$emit('step-type-change', this.wgoHelper.showStepType);
          break;
        case 'judge':
          if (this.mode === CHESSBOARD_MODES.PVP) {
            this.$emit('judge');
            return;
          }
          if (this.turnColor !== this.userColor)
            return this.$Message.warning(this.$t('還沒輪到你哦'));
          if (this.isAiThinking)
            return this.$Message.warning(
              this.$t('AI計算中') +
                this.$t('，') +
                this.$t('請耐心等待') +
                this.$t('～')
            );
          if (this.isScoreModalShow)
            return this.$Message.warning(this.$t('請先確認算輸贏結果'));
          const scoreStepLimit =
            GameConfig.scoreStepLimit[this.currentBoardSize];

          if (
            this.wgoHelper.step < scoreStepLimit &&
            this.mode !== CHESSBOARD_MODES.ENDGAME
          ) {
            this.$Message.warning(
              this.$t('{handicap}手以上才能申請算輸赢哦', {
                handicap: scoreStepLimit,
              })
            );
          } else {
            this.getInfluence();
          }
          break;
        case 'flag':
          this.isModalMessageBoxShow = true;
          BackEvent.addEvent(() => {
            this.onModalMessageBoxClick('cancel');
          });
          break;
        case 'moveCancle':
          this.cancelDoubleCheckPosition();
          break;
        case 'moveConfirm':
          const position = this.wgoHelper.editable._last_mark;
          const checkPosition = position || this.doubleCheckPosition;
          if (!this.isOnMoveOptions(checkPosition.x, checkPosition.y)) return;
          BackEvent.popEvent();

          if (
            this.wgoHelper.isValid(
              this.doubleCheckPosition.x,
              this.doubleCheckPosition.y
            ) ||
            this.chessType === 'markup'
          ) {
            if (this.chessType === 'markup') {
              this.wgoHelper.addMarkup({
                x: checkPosition.x,
                y: checkPosition.y,
                type: 'M',
              });
            } else {
              this.wgoHelper.play(checkPosition);
            }
            this.cancelDoubleCheckPosition();
          }
          break;
        case 'supportGame':
          this.$emit('support-game');
          break;
        case 'testPlay':
          this.isInfluence = false;
          this.influenceController.removeInfluence();
          this.testPlay();
          break;
        case 'watchAnswer':
          this.$emit('watch-answer');
          break;
        case 'nextQuestion':
          this.$emit('next-question');
          break;
        case 'influence':
          this.isInfluence = !this.isInfluence;
          this.isInfluence
            ? this.influenceController.draw()
            : this.influenceController.removeInfluence();
          break;
        case 'toggleCoordinates':
          const isCoordinateShow = this.wgoHelper.toggleCoordinates();
          this.$emit('coordinates-change', isCoordinateShow);
          break;
        case 'pass':
          if (this.mode === CHESSBOARD_MODES.PVP) {
            if (this.isLastMovePass) {
              this.$Message.info(this.$t('雙方虛手，將進入算輸贏'));
            } else {
              this.$Message.info(this.$t('你已虛手'));
            }
            this.wgoHelper.pass();
            return;
          }
          if (this.mode !== CHESSBOARD_MODES.PVP) {
            if (this.turnColor !== this.userColor) {
              return this.$Message.warning(this.$t('還沒輪到你哦'));
            }
            if (this.isLastMovePass) {
              this.$Message.info(this.$t('雙方虛手，將進入算輸贏'));
              return this.onToolbarClick('judge');
            }
            this.wgoHelper.pass();
          }

          break;
        case 'nextFusekiQuestion':
          this.wgoHelper.nextFusekiQuestion();
          break;
        case 'prevFusekiQuestion':
          this.wgoHelper.prevFusekiQuestion();
          break;
      }
    },
    moveChess(direction) {
      const size = this.wgoHelper.boardWidth;
      const originPosition = this.wgoHelper.editable._last_mark;
      let {x, y} = originPosition;
      switch (direction) {
        case 'top':
          y -= 1;
          break;
        case 'bottom':
          y += 1;
          break;
        case 'left':
          x -= 1;
          break;
        case 'right':
          x += 1;
          break;
        default:
          return;
      }
      if (x >= size || y >= size || x < 0 || y < 0) return;
      this.doubleCheckPosition = {x, y};
      this.wgoHelper.editable.setHoverStonePosition(x, y);
      if (!this.wgoHelper.isValid(x, y)) {
        this.wgoHelper.editable._last_mark = Object.assign(
          {},
          originPosition,
          this.doubleCheckPosition
        );
      }
    },
    cancelDoubleCheckPosition() {
      BackEvent.clearEvents('moveCancle');
      this.wgoHelper.editable.clearHoverStone();
      this.doubleCheckPosition = null;
      this.chessboardToolbarMode = this.toolbar;
    },
    async getInfluence() {
      const isShowRedFilter =
        !this.isVerification && this.mode !== CHESSBOARD_MODES.ENDGAME;
      this.$store.commit('env/setIsLoading', true);
      this.chessboardToolbarMode = '';
      this.wgoHelper.setFrozen(true);
      try {
        const result = await this.wgoHelper.getJudgement({isShowRedFilter});
        this.$store.commit('env/setIsLoading', false);
        if (result.resultError) {
          this.$Message.warning(this.$t(`${result.resultError}`), 1000 * 5);
          this.isScoreModalShow = false;
          this.wgoHelper.setFrozen(false);
        } else {
          this.isScoreModalShow = true;
          this.showJudgementResult(result);
        }
      } catch (error) {
        this.$Message.error(error);
      }
    },
    checkAnswerTab(value, index) {
      this.$emit('check-answer-tab-change', value);
      switch (value) {
        case 'myAnswer':
          this.showMyAnswer();
          break;
        case 'question':
          this.showQuestion();
          break;
        case 'answer':
          this.showAnswer(index);
          break;
      }
    },
    onClickVideo(question) {
      this.$emit('on-click-video', question);
    },
    showMyAnswer() {
      const _question = JSON.parse(JSON.stringify(this.question));
      if (!_question.userAnswer) {
        this.wgoHelper.loadSgf(_question.sgf);
        return;
      }
      this.wgoHelper.loadSgf(_question.userAnswer.sgf);
      this.wgoHelper.showAnswerMarkups();
      this.wgoHelper.setFrozen(false);
      this.wgoHelper.showStep('all');
      this.wgoHelper.last();
      this.wgoHelper.setFrozen(true);
    },
    showQuestion() {
      this.wgoHelper.setConfig({
        displayVariations: false,
      });
      this.wgoHelper.loadSgf(this.sgf);
      this.wgoHelper.hideAnswerMarkups();
      this.wgoHelper.setFrozen(true);
    },
    showAnswer() {
      this.wgoHelper.setConfig({
        displayVariations: true,
      });
      this.wgoHelper.loadSgf(this.question.sgf);
      this.wgoHelper.showAnswerMarkups();
      this.wgoHelper.setFrozen(false);
      this.wgoHelper.showStep('all');
      this.wgoHelper.last();
    },
    goto(step) {
      this.hideReviewHand();
      this.wgoHelper.setFrozen(false);
      this.wgoHelper.goto(step);
      if (!this.isTestPlay && this.toolbar !== 'checkAnswer')
        this.wgoHelper.setFrozen(true);
    },
    async checkStep(event) {
      this.hideReviewHand();
      this.wgoHelper.setFrozen(false);
      switch (event) {
        case 'prev':
          this.wgoHelper.prev();
          break;
        case 'next':
          this.wgoHelper.next();
          break;
        case 'first':
          this.wgoHelper.first();
          break;
        case 'next-ten':
          this.wgoHelper.next10();
          break;
        case 'prev-ten':
          this.wgoHelper.prev10();
          break;
        case 'last':
          this.wgoHelper.last();
          break;
      }
      if (!this.isTestPlay) this.wgoHelper.setFrozen(true);
    },
    // 算輸贏結果Modal
    showJudgementResult(result) {
      this.isModalJudgementResultShow = true;
      this.scoreResult = result;
      this.winningWay = result.winningWay;

      this.$emit('on-judge', {
        isModalJudgementResultShow: true,
        winningWay: this.getWinningWayText(),
      });
      BackEvent.addEvent(() => {
        this.checkJudgementResult('cancel');
      });
    },
    async checkJudgementResult(value) {
      BackEvent.popEvent();
      if (value === 'confirm') {
        if (this.isAiThinking) return;
        this.$store.commit('env/setIsLoading', true);
        await this.wgoHelper.confirmJudgement({
          winningWay: this.getWinningWayText(),
        });
        this.$store.commit('env/setIsLoading', false);
        this.isModalJudgementResultShow = false;
        this.chessboardToolbarMode = 'game';
        this.isScoreModalShow = false;
      } else if (value === 'cancel') {
        this.isModalJudgementResultShow = false;
        this.chessboardToolbarMode = 'game';
        this.isScoreModalShow = false;
        this.wgoHelper.setFrozen(false);
        this.wgoHelper.clearInfluenceMarkup();
        this.$emit('on-judge', {
          isModalJudgementResultShow: false,
          winningWay: this.getWinningWayText(),
        });
      }
    },
    onModalMessageBoxClick(value) {
      BackEvent.popEvent();
      this.isModalMessageBoxShow = false;
      if (value === 'confirm') {
        if (this.mode !== CHESSBOARD_MODES.PVP) {
          this.wgoHelper.resign();
        }
        this.$emit('resign');
      }
    },
    beforeLaozi(x, y) {
      if (
        this.laoziSetting &&
        !this.isTestPlay &&
        this.chessboardToolbarMode !== 'checkAnswer'
      ) {
        this.wgoHelper.editable.isNoBoldGrid = false;
        if (!this.wgoHelper.player.frozen) {
          this.wgoHelper.editable.setHoverStonePosition(x, y);
        }
        if (
          !this.wgoHelper.player.frozen &&
          (this.wgoHelper.isValid(x, y) || this.chessType === 'markup')
        ) {
          this.chessboardToolbarMode = this.customToolbar || 'check2Chess';
          BackEvent.addEvent(() => {
            this.cancelDoubleCheckPosition();
          }, 'moveCancle');
          this.wgoHelper.editable.frozenHoverStone();
          this.doubleCheckPosition = {x, y};
        }
      } else {
        this.wgoHelper.editable.isNoBoldGrid = true;
        if (this.chessType === 'markup' && !this.wgoHelper.player.frozen) {
          this.wgoHelper.addMarkup({x, y, type: 'M'});
        } else if (
          this.mode === CHESSBOARD_MODES.BOARD &&
          this.toolbar === 'checkAnswer' &&
          this.checkAnswerSelectedTab !== 'question' &&
          !this.isTestPlay
        ) {
          const isBranch = this.wgoHelper.isBranch({x, y});
          if (isBranch) {
            this.wgoHelper.setFrozen(false);
            this.wgoHelper.play({x, y});
            this.wgoHelper.setFrozen(true);
          }
        } else {
          this.wgoHelper.play({x, y});
        }
      }
    },
    loadSgf(sgf) {
      this.wgoHelper.loadSgf(sgf);
    },
    // 覆盤顯示問題手或正解
    showReviewHand(reviewHandPathMove, type) {
      this.wgoHelper.showStep('');
      if (type === 'question') {
        this.wgoHelper.setFrozen(false);
        this.wgoHelper.goto(this.currentStep);
        this.wgoHelper.setFrozen(true);

        const questionHandPosition = this.wgoHelper.player.kifuReader.node.move;
        this.wgoHelper.removeMarkup({
          x: questionHandPosition.x,
          y: questionHandPosition.y,
        });
        this.wgoHelper.addMarkup({
          x: questionHandPosition.x,
          y: questionHandPosition.y,
          type: 'LB',
          text: 'i-e99a',
          c: '#DC3545',
        });
        this.wgoHelper.removeMarkup({
          x: reviewHandPathMove.x,
          y: reviewHandPathMove.y,
          type: 'M',
        });
      } else if (type === 'suggest') {
        this.suggestPathMove = reviewHandPathMove;
        this.wgoHelper.setFrozen(false);
        this.wgoHelper.prev();
        this.wgoHelper.play({x: reviewHandPathMove.x, y: reviewHandPathMove.y});
        this.wgoHelper.addMarkup({
          x: reviewHandPathMove.x,
          y: reviewHandPathMove.y,
          type: 'M',
        });
        this.wgoHelper.setFrozen(true);
      } else if (type === 'excellent') {
        this.wgoHelper.removeMarkup({
          type: 'LB',
          x: reviewHandPathMove.x,
          y: reviewHandPathMove.y,
        });
        this.wgoHelper.addMarkup({
          x: reviewHandPathMove.x,
          y: reviewHandPathMove.y,
          type: 'LB',
          text: 'i-e999',
          c: '#42DB44',
        });
      }
    },
    getWinningWayText() {
      return filters.winningWayText(
        this.winningWay,
        this.scoreRule,
        this.komi,
        this.boardSize
      );
    },
    hideReviewHand() {
      if (this.suggestPathMove) {
        this.wgoHelper.removeMarkup({
          x: this.suggestPathMove.x,
          y: this.suggestPathMove.y,
          type: 'M',
        });
        this.wgoHelper.setFrozen(false);
        this.wgoHelper.dropBranch();
        this.wgoHelper.setFrozen(true);
        this.suggestPathMove = null;
      }
      if (this.wgoHelper.showStepType === '') {
        this.wgoHelper.showStep('normal');
        this.$emit('step-type-change', this.wgoHelper.showStepType);
      }
    },
    addMarkup({path, type, text}) {
      this.wgoHelper.addMarkup({
        x: path.x,
        y: path.y,
        type,
        text,
      });
    },
    // 試下相關
    testPlay() {
      this.isTestPlay = !this.isTestPlay;
      if (this.isTestPlay) {
        this.chessboardToolbarMode = 'testPlay';
      } else if (this.variation.length > 0) {
        this.chessboardToolbarMode = 'checkVariation';
      } else {
        this.chessboardToolbarMode = this.toolbar;
      }
      if (this.isTestPlay) {
        this.wgoHelper.setFrozen(false);
        this.wgoHelper.setEditable(true);
        this.testPlayState = this.wgoHelper.startTestPlay();
        this.wgoHelper.showStep('all');
      } else {
        if (this.mode === 'checkKifu' || this.toolbar === 'checkKifu') {
          this.wgoHelper.setFrozen(true);
          this.wgoHelper.setEditable(false);
        }
        this.wgoHelper.endTestPlay(this.testPlayState);
        this.testPlayState = null;
        if (this.variation.length > 0 || this.toolbar === 'checkAnswer') {
          this.wgoHelper.showStep('all');
          // 在 checkAnswer 模式下，根據當前選中決定是否鎖住棋盤
          if (this.toolbar === 'checkAnswer') {
            // 只有在 'question' 和 'myAnswer' 時才鎖住棋盤
            // 'answer' 標籤保持解鎖狀態以便查看變化圖
            if (
              this.checkAnswerSelectedTab === 'question' ||
              this.checkAnswerSelectedTab === 'myAnswer'
            ) {
              this.wgoHelper.setFrozen(true);
            }
          }
        } else {
          this.wgoHelper.showStep('normal');
        }
      }
      this.$emit('is-test-play', this.isTestPlay);
    },
    getBoardImgBase64() {
      const canvasList = [
        ...this.wgoHelper?.editable?.board?.element?.children,
      ];
      if (!canvasList?.length) return null;
      const tempCanvas = document.createElement('canvas');
      const width = canvasList[0].width;
      const height = canvasList[0].height;
      tempCanvas.width = width;
      tempCanvas.height = height;
      const ctx = tempCanvas.getContext('2d');
      ctx.fillStyle = this.chessboardImageStyle.backgroundColor;
      ctx.fillRect(0, 0, width, height);
      canvasList.forEach((item) => {
        ctx.drawImage(item, 0, 0, width, height);
      });
      const base64 = tempCanvas.toDataURL('image/png');
      return base64;
    },
    async updateGame(move, deltaMs, isNeedSendTime, retryCount = 0) {
      try {
        if (retryCount > 0) {
          this.$store.commit('env/setIsLoading', true);
        }
        const result = await this.$store.dispatch('aiGame/updateGame', {
          move,
          deltaMs,
          isNeedSendTime,
        });
        this.$store.commit('env/setIsLoading', false);
        return result;
      } catch (error) {
        if (
          error.message !== 'Network Error' &&
          error.code !== 'ECONNABORTED'
        ) {
          // 如果不是網路錯誤，都直接跳錯誤訊息
          throw new Error('請確認網路連線的狀態後再次嘗試');
        }
        // 如果是網路錯誤，則執行重試機制
        if (retryCount >= 20) {
          throw new Error('請確認網路連線的狀態後再次嘗試');
        }
        await delay(1000 * 2);
        return this.updateGame(move, deltaMs, isNeedSendTime, retryCount + 1);
      }
    },
    async nextMove(retryCount = 0) {
      try {
        if (retryCount > 0) {
          this.$store.commit('env/setIsLoading', true);
        }
        const result = await this.$store.dispatch(
          'aiGame/nextMove',
          retryCount
        );
        this.$store.commit('env/setIsLoading', false);
        return result;
      } catch (error) {
        if (
          error.message !== 'Network Error' &&
          error.code !== 'ECONNABORTED'
        ) {
          // 如果不是網路錯誤，都直接跳錯誤訊息
          throw new Error('請確認網路連線的狀態後再次嘗試');
        }
        // 如果是網路錯誤，則執行重試機制
        if (retryCount >= 20) {
          throw new Error('請確認網路連線的狀態後再次嘗試');
        }
        await delay(1000 * 2);
        return this.nextMove(retryCount + 1);
      }
    },
    addErrorStepMarkup({x, y}) {
      this.errorStepMove = {x, y};
      const rows = this.wgoHelper.player.board.obj_arr[x][y];
      rows.forEach((item) => {
        if (item.type) {
          this.wgoHelper.removeObject({
            type: item.type,
            x: item.x,
            y: item.y,
          });
        }
      });
      this.wgoHelper.addObject({
        x,
        y,
        type: 'LB',
        text: 'i-e99a',
        c: '#FF6767',
      });
    },
    removeErrorStepMarkup() {
      if (!this.errorStepMove) return;
      this.wgoHelper.removeObject({
        x: this.errorStepMove.x,
        y: this.errorStepMove.y,
        type: 'LB',
      });
      this.errorStepMove = null;
    },

    redrawBoard: _.debounce(
      /**
       * @this VueComponent
       */
      function () {
        this._redrawBoard();
      },
      1000 / 60
    ),
    _redrawBoard() {
      if (!this.wgoHelper) return;
      if (this.$device.isMobile || !this.needResize) {
        const element = document.getElementById(this.playerId);
        const width = element.clientWidth;
        this.wgoHelper.player.board.setDimensions(width, width);
      } else {
        const body = document.body;
        const height = body.clientHeight;
        const width = body.clientWidth;
        const boardWidth1 = height - 56 - 48;
        const boardWidth2 = width - 289 - 32 - 48;
        const boardWidth = Math.min(boardWidth1, boardWidth2);
        this.wgoHelper.player.board.setDimensions(boardWidth, boardWidth);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
:deep() .chessboard {
  width: 100%;
  height: 100%;
  canvas {
    left: 0;
  }
}
.chessboard-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  @media screen and (min-width: 768px) {
    margin: 0 auto;
  }
  .chessboard-container {
    position: relative;
  }
}
.board-image {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
}
.chessboard-toolbar.fixed-height {
  min-height: 48px;
}
.modal-judgement-result .card {
  border-width: 3px;
}
.isCorrect {
  position: absolute;
  top: calc(50% - 75px);
  left: calc(50% - 75px);
  width: 150px;
  height: 150px;
  z-index: 300;
  animation: exterior 0.4s 0.04s;
  span {
    font-size: 150px;
    animation: icono 0.6s 0.08s;
  }
  .icon-Colorful-correct-gray .path2,
  .icon-Colorful-correct .path2,
  .icon-Colorful-error .path2 {
    position: absolute;
    top: 0;
    left: 0;
  }
  .icon-Colorful-correct-gray .path2::before,
  .icon-Colorful-correct .path2::before,
  .icon-Colorful-error .path2::before {
    margin-left: 0;
  }
  @keyframes exterior {
    0% {
      transform: scale(1);
    }
    25% {
      transform: scale(0.7);
    }
    50% {
      transform: scale(1);
    }
    75% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes icono {
    0% {
      transform: scale(1);
    }
    25% {
      transform: scale(1.2);
    }
    50% {
      transform: scale(1.4);
    }
    75% {
      transform: scale(0.8);
    }
    100% {
      transform: scale(1);
    }
  }
}
</style>
